import React from "react";

function Template4() {
  const mockData = {
    template2: {
      pagetitle: "AristAI Offerings and Intelligent Education Tools",
      content1:
        "AristAI is an AI-powered education platform that transforms learning for institutions, educators, and students. It offers a suite of intelligent tools that enhance tutoring, accessibility, and curriculum management through advanced automation and AI models.",
      content2:
        "By integrating seamlessly into existing educational systems, AristAI enables real-time support, automated content enhancement, and curriculum analytics. The platform caters to a wide range of educational needs, improving engagement, inclusivity, and operational efficiency.",
      section1: {
        subsection1: "AI Tutor and Lesson Recaps",
        subsection2:
          "AristAI's AI Tutor provides 24/7 virtual teaching assistance by answering student questions using course materials and educator-defined knowledge. The AI Podcast feature generates personalized lesson summaries to support student retention and educator insights.",
        subsection3:
          "These tools support deeper learning engagement and allow educators to scale support across large student cohorts without sacrificing personalization.",
      },
      section2: {
        subsection1: "AI Accessibility Suite",
        subsection2:
          "The AI Accessibility Suite helps institutions meet WCAG 2.2 compliance standards by automatically generating captions, descriptive transcripts, and accessible media players for videos and documents.",
        subsection3:
          "This automation dramatically reduces manual accessibility efforts and ensures inclusive experiences for all learners, including those with disabilities.",
      },
      section3: {
        subsection1: "Curriculum Program Mapper",
        subsection2:
          "The Program Mapper analyzes course content and maps topic coverage across programs, offering curriculum designers actionable insights to close learning gaps and improve coherence.",
        subsection3:
          "Administrators can use this tool to ensure alignment with academic goals and accreditation standards while saving time on manual curriculum reviews.",
      },
      section4: {
        subsection1: "Seamless Integration and Analytics",
        subsection2:
          "AristAI integrates with existing learning platforms and supports API-based deployments for secure and scalable implementations. Real-time analytics provide educators with actionable data on student progress, knowledge gaps, and content performance.",
        subsection3:
          "These insights help institutions continuously improve learning outcomes while ensuring compliance and transparency.",
      },
    },
  };

  const handleGoBack = () => {
    window.location.href = "/";
  };

  return (
    <div style={{ ...styles.container, ...styles.fadeIn }}>
      <button onClick={handleGoBack} style={styles.closeButton} aria-label="Close and return to home">
        ✕
      </button>
      {/* Left Section */}
      <div style={styles.leftSection}>
        <h1 style={styles.mainTitle}>{mockData.template2.pagetitle}</h1>
        <p style={styles.description}>{mockData.template2.content1}</p>
        <p style={styles.description}>{mockData.template2.content2}</p>
        <img src="https://d2hp1ftv5ri2om.cloudfront.net/assets/logos/logo_wiz_emblem.webp" alt="AristAI Logo" style={{
          width: "100%",
          maxWidth: "300px",
          marginTop: "2rem",
        }} />
      </div>

      {/* Right Section */}
      <div style={styles.rightSection}>
        <div style={styles.contentBox}>
          <div style={styles.iconBox}></div>
          <div style={styles.textContent}>
            <h2 style={styles.heading}>{mockData.template2.section1.subsection1}</h2>
            <p style={styles.text}>{mockData.template2.section1.subsection2}</p>
          </div>
        </div>

        <div style={styles.contentBox}>
          <div style={styles.iconBox}></div>
          <div style={styles.textContent}>
            <h2 style={styles.heading}>{mockData.template2.section2.subsection1}</h2>
            <p style={styles.text}>{mockData.template2.section2.subsection2}</p>
          </div>
        </div>

        <div style={styles.contentBox}>
          <div style={styles.iconBox}></div>
          <div style={styles.textContent}>
            <h2 style={styles.heading}>{mockData.template2.section3.subsection1}</h2>
            <p style={styles.text}>{mockData.template2.section3.subsection2}</p>
          </div>
        </div>

        <div style={styles.contentBox}>
          <div style={styles.iconBox}></div>
          <div style={styles.textContent}>
            <h2 style={styles.heading}>{mockData.template2.section4.subsection1}</h2>
            <p style={styles.text}>{mockData.template2.section4.subsection2}</p>
          </div>
        </div>
      </div>
    </div>
  );
}

const styles = {
  container: {
    display: "flex",
    backgroundColor: "#000",
    color: "#fff",
    minHeight: "100vh",
    padding: "3rem",
    gap: "4rem",
    margin: "0 auto",
    position: "absolute",
    top: "0",
    left: "0",
    right: "0",
    bottom: "0",
  },
  fadeIn: {
    animation: "fadeInFromLeft 0.8s ease-out forwards",
    opacity: 0,
  },
  leftSection: {
    flex: "1",
    paddingTop: "2rem",
  },
  rightSection: {
    flex: "1",
    display: "flex",
    flexDirection: "column",
    gap: "2rem",
    paddingTop: "4rem",
  },
  mainTitle: {
    fontSize: "3.5rem",
    fontWeight: "bold",
    marginBottom: "2rem",
    lineHeight: "1.2",
  },
  description: {
    fontSize: "1.1rem",
    lineHeight: "1.6",
    color: "#999",
    marginBottom: "1rem",
  },
  contentBox: {
    display: "flex",
    gap: "1.5rem",
    alignItems: "flex-start",
  },
  iconBox: {
    width: "48px",
    height: "48px",
    backgroundColor: "#333",
    borderRadius: "8px",
    flexShrink: 0,
  },
  textContent: {
    flex: "1",
  },
  heading: {
    fontSize: "1.25rem",
    fontWeight: "bold",
    marginBottom: "0.5rem",
    marginTop: "0",
  },
  text: {
    fontSize: "1rem",
    lineHeight: "1.6",
    color: "#999",
  },
  closeButton: {
    position: "absolute",
    top: "20px",
    right: "20px",
    width: "40px",
    height: "40px",
    borderRadius: "50%",
    backgroundColor: "transparent",
    border: "1px solid #fff",
    color: "#fff",
    fontSize: "20px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    transition: "all 0.3s ease",
    zIndex: 10,
  },
};

// Add the keyframes animation to the document
const styleSheet = document.createElement("style");
styleSheet.textContent = `
  @keyframes fadeInFromLeft {
    from {
      opacity: 0;
      transform: translateX(-50px);
    }
    to {
      opacity: 1;
      transform: translateX(0);
    }
  }
`;
document.head.appendChild(styleSheet);

export default Template4;
